<template>
  <div class="container">
    <!-- 保修详情信息 -->
    <div class="warranty-details-info">
      <div class="warranty-details-info-title">咨询信息</div>
      <div class="warranty-details-info-content">
        <div class="warranty-details-info-content-left">
          <span>资讯类型：</span>
          <span>{{details.consultTypeName}}</span>
        </div>
        <div class="warranty-details-info-content-left">
          <span>申请时间：</span>
          <span>{{details.applyDate}}</span>
        </div>
        <div class="warranty-details-info-content-left">
          <span>申请人：</span>
          <span>{{details.userName}}</span>
        </div>
        <div class="warranty-details-info-content-left">
          <span>联系人：</span>
          <span>{{details.consultName}}</span>
        </div>
        <div class="warranty-details-info-content-left">
          <span>联系电话：</span>
          <span>{{details.consultPhone}}</span>
        </div>
        <div class="warranty-details-info-content-left clearfix">
          <span class="more-title">问题描述：</span>
          <span class="more-content">{{details.questionDescribe}}</span>
        </div>
        <div class="warranty-details-info-img">
          <div>上传图片：</div>
          <div>
            <img
              v-for="(item,index) in pictureList"
              :key="index"
              class="more-img"
              :src="item.url"
              alt
              srcset
              @click="HandleclickImg(index)"
            />
          </div>
          <!-- <span class="more-title" style="color:#999999;margin-left:0">上传图片</span>
          <img v-for="(item,index) in pictureList" :key="index" class="more-img" :src="item.url" alt srcset />-->
        </div>
      </div>
    </div>
    <!-- 咨询恢复 -->
    <div class="warranty-details-info" v-show="details.consultStatus == 2">
      <div class="warranty-details-info-title">咨询回复</div>
      <div class="warranty-details-info-content">
        <div class="warranty-details-info-content-left">
          <span>回复人：</span>
          <span>{{details.replyName}}</span>
        </div>
        <div class="warranty-details-info-content-left">
          <span class="more-title">问题描述：</span>
          <span class="more-content">{{details.replyContent}}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { ConsultaionDetails } from "@/api/consultation";
import { ImagePreview } from "vant";
export default {
  data() {
    return {
      details: "",
      pictureList: [],
      ImagePreview: []
    };
  },
  mounted() {
    this.requestConsultaionDetails();
  },
  methods: {
    requestConsultaionDetails() {
      // let id = this.$route.query.id;
      let formIdOrWorkId = this.$utils.getUrlKey('professionalConsultationId')
      ConsultaionDetails({ dataId:formIdOrWorkId }).then(res => {
        console.log(res);
        this.details = res.data;
        this.pictureList = res.data.pictureList;
        res.data.pictureList.forEach(element => {
          console.log(element);
          this.ImagePreview.push(element.url);
        });
      });
    },
    // 点击查看大图
    HandleclickImg(index) {
      ImagePreview({
        images: this.ImagePreview,
        startPosition: index
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.container {
  width: 100%;
  height: 100%;
  background-color: #f6f6f6;
  overflow-x: hidden;
  // 保修信息
  .warranty-details-info {
    width: 350px;
    margin: 10px 13px;
    background-color: #ffffff;
    text-align: left;
    border-radius: 10px;
    .warranty-details-info-title {
      width: 100%;
      height: 50px;
      line-height: 50px;
      padding-left: 15px;
      box-sizing: border-box;
      border-bottom: 1px solid #eeeeee;
      color: #404051;
      font-size: 16px;
      font-weight: bold;
    }
    .warranty-details-info-content {
      width: 100%;
      padding: 15px 15px;
      box-sizing: border-box;
      color: #404051;
      font-size: 14px;
      //  每一行的信息
      .warranty-details-info-content-left {
        position: relative;
        margin: 15px 0;
        span {
          &:first-child {
            display: inline-block;
            width: 85px;
            padding: 5px;
            box-sizing: border-box;
            color: #999999;
          }
          &:last-child {
            display: inline-block;
            width: 203px;
            color: #333333;
            margin-left: 30px;
          }
        }
         .more-title {
          display: inline-block;
          width: 85px;
          padding: 5px;
          position: absolute;
          top: 0;
        }
      .more-content {
          margin-left: 117px !important;
        }
      }
      // 处理图片的左右布局
      .warranty-details-info-img {
        display: flex;
        margin-top: 30px;
        div {
          &:first-child {
            width: 110px;
            color: #999999;
            padding: 5px;
            box-sizing: border-box;
          }
          .more-img {
            width: 30px;
            height: 30px;
          }
        }
      }
    }
  }
}
</style>
